export * from './lib/order-customer-info/order-customer-info.component';
